import { AnimatePresence, motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { Activity, Grid3x3, LayoutDashboard, Menu as MenuIcon, Users, X } from "lucide-react";
import { NAV_GROUPS } from "../../dashboard/nav";
import { SidebarContent } from "./Sidebar";

const BOTTOM = [
    { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/dashboard/team", label: "Team", icon: Users },
    { to: "/dashboard/matrix", label: "Matrix", icon: Grid3x3 },
    { to: "/dashboard/activity", label: "Activity", icon: Activity },
];

export const MobileNav = ({ onMenu }) => (
    <nav
        className="fixed inset-x-0 bottom-0 z-40 border-t border-white/5 bg-nx-ink/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-lg lg:hidden"
        data-testid="mobile-bottom-nav"
        aria-label="Mobile navigation"
    >
        <div className="grid grid-cols-5">
            {BOTTOM.map((item) => (
                <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.end}
                    data-testid={`bottom-nav-${item.label.toLowerCase()}`}
                    className={({ isActive }) =>
                        `flex flex-col items-center gap-1 py-2.5 text-[10px] font-bold transition-colors duration-200 ${
                            isActive ? "text-nx-lime" : "text-nx-mute"
                        }`
                    }
                >
                    <item.icon size={17} strokeWidth={1.5} aria-hidden="true" />
                    {item.label}
                </NavLink>
            ))}
            <button
                type="button"
                onClick={onMenu}
                data-testid="bottom-nav-menu"
                className="flex flex-col items-center gap-1 py-2.5 text-[10px] font-bold text-nx-mute transition-colors duration-200"
            >
                <MenuIcon size={17} strokeWidth={1.5} aria-hidden="true" />
                Menu
            </button>
        </div>
    </nav>
);

export const MobileDrawer = ({ open, onClose }) => (
    <AnimatePresence>
        {open && (
            <>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.2 }}
                    onClick={onClose}
                    className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm lg:hidden"
                    data-testid="drawer-backdrop"
                    aria-hidden="true"
                />
                <motion.aside
                    initial={{ x: "-100%" }}
                    animate={{ x: 0 }}
                    exit={{ x: "-100%" }}
                    transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed inset-y-0 left-0 z-50 w-72 border-r border-white/10 bg-nx-ink lg:hidden"
                    data-testid="mobile-drawer"
                    aria-label="Menu"
                >
                    <button
                        type="button"
                        onClick={onClose}
                        data-testid="drawer-close"
                        aria-label="Close menu"
                        className="absolute right-3 top-4 flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 bg-nx-elev text-nx-sub"
                    >
                        <X size={16} strokeWidth={1.5} aria-hidden="true" />
                    </button>
                    <div className="h-full pt-0">
                        <SidebarContent onNavigate={onClose} />
                    </div>
                </motion.aside>
            </>
        )}
    </AnimatePresence>
);

export const extraNavLabels = NAV_GROUPS.flatMap((g) => g.items.map((i) => i.label));
